import axios from "axios";
import { API_URL } from "../api";
import {
  AREAS_LOADING,
  GET_AREAS_SUCCESS,
  GET_AREAS_FAILURE,
  SET_AREAS_SEARCH,
  SET_AREAS_PAGE,
  GET_AREA_INFO_SUCCESS,
  GET_AREA_INFO_FAILURE,
  RESET_AREAS_REDUCER
} from "./types/areas";
import { SHOW_ALERT_SUCCESS, SHOW_ALERT_ERROR } from "./types/alertTypes";
import ErrorHandler from "../lib/ErrorHandler";
import { logout } from "./authActions";

export const getAreas = (filters, allProvinces = false) => async dispatch => {
  try {
    dispatch({ type: AREAS_LOADING });

    const endPoint = `${API_URL}/api/admin/areas`;
    const pageParams = `?page=${filters && filters.page}`;

    let URL = `${endPoint}${!allProvinces ? pageParams : "?pagination=600"}`;

    if (filters && filters.query.length > 0) {
      const searchParams = `&name=${filters.query}`;
      URL = `${URL}${searchParams}`;
    }

    const response = await axios.get(URL);

    dispatch({
      type: GET_AREAS_SUCCESS,
      payload: {
        areas: response.data.data,
        links: {
          first: response.data.links.first,
          last: response.data.links.last,
          next: response.data.links.next,
          prev: response.data.links.prev
        },
        meta: {
          from: response.data.meta.from,
          to: response.data.meta.to,
          total: response.data.meta.total
        }
      }
    });

    return response.status;
  } catch (error) {
    dispatch({ type: GET_AREAS_FAILURE });

    if (error.response && error.response.status === 422) {
      const errorList = ErrorHandler(error.response.data.errors);
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: errorList
      });
    } else if (error.response && error.response.status === 401) {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["No autenticado."]
      });
      dispatch(logout());
    } else {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["Ocurrio un error, intentalo de nuevo."]
      });
    }

    return error.response.status;
  }
};

export const updateArea = (id, area) => async dispatch => {
  try {
    const response = await axios.put(`${API_URL}/api/admin/areas/${id}`, area);

    if (response.status === 200) {
      dispatch({
        type: SHOW_ALERT_SUCCESS,
        message: [`La Localidad ${area.name} fue editada satisfactoriamente.`]
      });
    }

    return response.status;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const errorList = ErrorHandler(error.response.data.errors);
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: errorList
      });
    } else if (error.response && error.response.status === 401) {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["No autenticado."]
      });
      dispatch(logout());
    } else {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["Ocurrio un error, intentalo de nuevo."]
      });
    }

    return error.response.status;
  }
};

export const getAreaById = id => async dispatch => {
  dispatch({ type: AREAS_LOADING });
  try {
    const response = await axios.get(`${API_URL}/api/admin/areas/${id}`);

    dispatch({
      type: GET_AREA_INFO_SUCCESS,
      payload: {
        area: response.data.area
      }
    });

    return response.status;
  } catch (error) {
    dispatch({ type: GET_AREA_INFO_FAILURE });

    if (error.response && error.response.status === 422) {
      const errorList = ErrorHandler(error.response.data.errors);
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: errorList
      });
    } else if (error.response && error.response.status === 401) {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["No autenticado."]
      });
      dispatch(logout());
    } else {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["Ocurrio un error, intentalo de nuevo."]
      });
    }

    return error.response.status;
  }
};

export const addArea = area => async dispatch => {
  try {
    const response = await axios.post(`${API_URL}/api/admin/areas`, area);

    if (response.status === 200) {
      dispatch({
        type: SHOW_ALERT_SUCCESS,
        message: [`La Localidad ${area.name} fue agregada satisfactoriamente.`]
      });
    }

    return response.status;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const errorList = ErrorHandler(error.response.data.errors);
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: errorList
      });
    } else if (error.response && error.response.status === 401) {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["No autenticado."]
      });
      dispatch(logout());
    } else {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["Ocurrio un error, intentalo de nuevo."]
      });
    }

    return error.response.status;
  }
};

export const deleteArea = id => async dispatch => {
  try {
    const response = await axios.delete(`${API_URL}/api/admin/areas/${id}`);

    if (response.status === 200) {
      dispatch({
        type: SHOW_ALERT_SUCCESS,
        message: [`La Localidad fue eliminada satisfactoriamente.`]
      });
    }

    return response.status;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const errorList = ErrorHandler(error.response.data.errors);
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: errorList
      });
    } else if (error.response && error.response.status === 401) {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["No autenticado."]
      });
      dispatch(logout());
    } else {
      dispatch({
        type: SHOW_ALERT_ERROR,
        message: ["Ocurrio un error, intentalo de nuevo."]
      });
    }

    return error.response.status;
  }
};

export const setSearchQuery = query => ({
  type: SET_AREAS_SEARCH,
  payload: {
    value: query
  }
});

export const setPage = page => ({
  type: SET_AREAS_PAGE,
  payload: {
    value: page
  }
});

export const resetAreas = () => ({
  type: RESET_AREAS_REDUCER
});
